import Vue from 'vue'
import VueRouter from 'vue-router'


import Login from "@/views/Login"
import History from "@/views/History"
import Over from "@/views/Over"
import ReturnPage from "@/views/ReturnPage"
import Demo from "@/views/Demo"
import Index from "@/views/Index"


Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: "/login",
  },
  {
    path: '/index',
    component: Index,
    meta:{
      title:"NPN Retailer Protal"
    }
  },

  {
    path: '/login',
    component: Login
  },
  {
    path: '/history',
    component: History
  },
  {
    name: 'over',
    path: '/over',
    component: Over
  },
  {
    path: '/return',
    component: ReturnPage
  },
  {
    path: '/demo',
    component: Demo,
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]





const router = new VueRouter({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next)=>{
  console.log(to.path,from.path)
  if(to.meta.titel){
    document.title = to.meta.titel
    next()
  }else{
    next()
  }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
return originalPush.call(this, location).catch(err => err)
}

export default router